import { render, staticRenderFns } from "./RequestStatusSelect.vue?vue&type=template&id=dec25e74&scoped=true&"
import script from "./RequestStatusSelect.vue?vue&type=script&lang=js&"
export * from "./RequestStatusSelect.vue?vue&type=script&lang=js&"
import style0 from "./RequestStatusSelect.vue?vue&type=style&index=0&id=dec25e74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec25e74",
  null
  
)

export default component.exports